/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

/**
 * Error Analytics API Service
 * 
 * Provides functions to interact with the error analytics endpoints
 */

import apiClient from '../services/api';
import { ErrorAnalytics, ErrorDetail } from '../types';

export const errorAnalyticsApi = {
  /**
   * Get error analytics dashboard data
   */
  getDashboard: async (days: number = 30): Promise<ErrorAnalytics> => {
    const response = await apiClient.get<ErrorAnalytics>('/ai/expert/api/error-analytics/dashboard/', {
      params: { days }
    });
    return response.data;
  },

  /**
   * Get detailed information about a specific error
   */
  getErrorDetail: async (errorId: string): Promise<ErrorDetail> => {
    const response = await apiClient.get<ErrorDetail>('/ai/expert/api/error-analytics/error_detail/', {
      params: { error_id: errorId }
    });
    return response.data;
  },
};

export default errorAnalyticsApi;
